import api from '../interceptors/interceptor';
import { API_ROUTES } from '../constants/apiRoutes';

export class ChatRepository {
  private static instance: ChatRepository;

  /**
   * Singleton pattern - ensure only one instance exists
   */
  public static getInstance(): ChatRepository {
    if (!ChatRepository.instance) {
      ChatRepository.instance = new ChatRepository();
    }
    return ChatRepository.instance;
  }

  /**
   * Get all models
   */
  public async chatCompletions(payload: any): Promise<any> {
    return (await api.post(API_ROUTES.CHAT_COMPLETIONS, payload))?.data;
  }

  /**
   * Stream chat completions using SSE
   */
  public async streamChatCompletion(
    body: any,
    onToken: (token: string) => void,
    onDone: () => void,
    onError: (err: any) => void,
    onWarning?: (warning: { type: string; message: string }) => void  
  ) {
    try {
      // Always use fetch for streaming in the browser
      const BASE_URL = window.env.REACT_APP_BASE_URL;
      const token = localStorage.getItem('access_token');
      const fetchResponse = await fetch(BASE_URL + API_ROUTES.CHAT_COMPLETIONS, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        },
        body: JSON.stringify({
          ...body,
          stream: true,
        }),
      });
      
      if (!fetchResponse.ok) {
      let errorJson: any = null;
      try {
        errorJson = await fetchResponse.json();
      } catch {
        onError({ type: "HTTP_ERROR", message: "Request failed" });
        return;
      }

      if (errorJson?.error === "TOKEN_LIMIT_EXCEEDED") {
        onError({
          type: "TOKEN_LIMIT_EXCEEDED",
          message: errorJson.response,
          details: errorJson.details,
        });
        return;
      }

      onError({
        type: "HTTP_ERROR",
        message: errorJson.response || "Request failed",
        status: fetchResponse.status,
      });
      return;
      }
      if (!fetchResponse.body) throw new Error("No response body");

      
      const reader = fetchResponse.body.getReader();
      const decoder = new TextDecoder("utf-8");
      let buffer = "";
      while (true) {
        const { value, done } = await reader.read();
        if (done) break;
        buffer += decoder.decode(value, { stream: true });
        const events = buffer.split("\n\n");
        buffer = events.pop() || "";
        for (const event of events) {
          if (!event.startsWith("data:")) continue;
          const data = event.replace("data:", "").trim();
          if (data === "[DONE]") {
            onDone();
            return;
          }
          try {
            const json = JSON.parse(data);
            // Check if this is a warning event
            if (json.warning) {
              if (onWarning) {
                onWarning({
                  type: json.warning,
                  message: json.message
                });
              }
              continue; 
            }
            
            // Regular token processing
            const token = json?.choices?.[0]?.delta?.content;
            if (token) onToken(token);
            
          } catch (e) {
            console.error("SSE parse error", e);
          }
        }
      }
      onDone();
    } catch (err) {
      onError(err);
    }
  }
}
